import {profileExperienceAdd} from '../../segment'
import {wrap} from '../../shared/loading-overlay.js'

angular
  .module('app.LawyerProfile')
  .directive('employmentHistory', employmentHistory)

function employmentHistory() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      candidate: '=',
      lawyerId: '=',
      lawyerApproved: '=',
      currentEmployer: '=',
      locations: '=',
      contracts: '=',
      occupations: '=',
      practices: '=',
      updateEmploymentInfo: '&',
    },
    template: require('./employment-history.html'),
    controller: employmentHistoryCtrl,
    link: employmentHistoryLink,
  }
}

require('./employment-history.api')

function employmentHistoryLink(scope) {
  scope.showAddEmploymentHistoryForm = () => {
    scope.addEmpHistory = true
    if (
      scope.candidate &&
      scope.candidate.experiences &&
      scope.candidate.experiences.length > 0
    ) {
      scope.candidate.experiences.forEach(history => {
        history.editEmpHistory = false
      })
    }

    scope.resetEmployment()
  }

  scope.hideAddEmploymentHistoryForm = () => {
    scope.addEmpHistory = false
  }

  scope.showEditEmploymentHistoryForm = employment => {
    scope.employment.refContractContractID = scope.employment
      .refContractContractID
      ? scope.employment.refContractContractID
      : 1
    scope.employment.refRoleRoleID = scope.employment.refRoleRoleID
      ? scope.employment.refRoleRoleID
      : 1
    scope.candidate.experiences.forEach(history => {
      history.editEmpHistory = false
    })

    scope.hideAddEmploymentHistoryForm()
    employment.editEmpHistory = true
  }

  scope.addEmploymentRecord = employment => {
    if (scope.candidate.experiences.length > 0) {
      scope.candidate.experiences.push(employment)
    } else {
      scope.candidate.experiences = [employment]
    }
  }

  scope.removeEmploymentRecord = workIndex => {
    scope.candidate.experiences.splice(workIndex, 1)
  }

  scope.editEmpHistory = (employment, editIndex) => {
    scope.employment = angular.copy(employment)
    scope.editIndex = editIndex
    scope.employment.isLastJob = !employment.end

    scope.showEditEmploymentHistoryForm(employment)
  }

  scope.updateEditedEmploymentRecord = employment => {
    scope.candidate.experiences[scope.editIndex] = employment
    scope.editIndex = -1
  }

  scope.cancelAddEditEmpHistory = () => {
    scope.hideAddEmploymentHistoryForm()
    scope.resetEmployment()
  }

  scope.cancelEditEmpHistory = employment => {
    employment.editEmpHistory = false
    scope.resetEmployment()
  }

  scope.trackExperience = (employment, eventName) => {
    console.debug('trackExperience', employment, eventName)
    let empLocations = [employment.location.name]
    let empPracticeAreas = []

    employment.specialties.forEach(pa => {
      empPracticeAreas.push(pa.name)
    })

    empLocations = empLocations.join()
    empPracticeAreas = empPracticeAreas.join()

    let trackExpObject = {
      employerName: employment.employer.name,
      jobTitle: employment.jobTitle,
      from: employment.start,
      to: employment.end,
      isLastJob: employment.isLastJob,
      contract: employment.contractType.name,
      role: employment.occupation.name,
      location: empLocations,
      practiceAreas: empPracticeAreas,
      action: eventName,
    }

    profileExperienceAdd(trackExpObject)

    try {
      if (employment.isLastJob) {
        analytics.identify({
          currentEmployerName: employment.employer.name,
          currentEmployerId: employment.employer.id,
        })
      }
    } catch (error) {
      console.error('Identify from experience', error)
    }
  }

  scope.resetEmployment = () => {
    scope.employment = {
      employer: {
        name: '',
      },
      jobTitle: '',
      start: '',
      end: '',
      isLastJob: false,
      contractTypeId: 1,
      occupationId: 1,
      comments: '',
      location: undefined,
      specialties: [],
    }
  }
}

function employmentHistoryCtrl(
  $scope,
  $modal,
  logger,
  sharedProperties,
  CandidateProfileApi,
  EmploymentHistoryApi
) {
  $scope.resetEmployment = () => {
    $scope.employment = {
      employer: {
        name: '',
      },
      jobTitle: '',
      start: '',
      end: '',
      isLastJob: false,
      contractTypeId: 1,
      occupationId: 1,
      comments: '',
      location: undefined,
      specialties: [],
    }
  }

  const initializeEmploymentHistory = async () => {
    $scope.resetEmployment()
    const {data: employersList} = await CandidateProfileApi.getEmployersList()
    const experiences = await CandidateProfileApi.getExperiences(
      $scope.candidate.id
    )
    const experienceList =
      experiences && experiences.data ? experiences.data : []

    $scope.employers = employersList
    $scope.candidate.experiences = experienceList
    if ($scope.candidate && $scope.candidate.experiences)
      formatFirmLogo($scope.candidate.experiences)

    $scope.$apply()
  }

  initializeEmploymentHistory()

  $scope.hideAllEmpHistories = histories => {
    histories.forEach(history => {
      history.editEmpHistory = false
    })
  }

  let arePracticeAreasMandatory = () => {
    let practiceAreas = $scope.employment.specialties
    return !sharedProperties.isAdminSession() && _.isEmpty(practiceAreas)
  }

  function validateEmploymentParameters() {
    let employment = $scope.employment
    $scope.employment.errors = {}
    if (
      !employment.start ||
      (!employment.isLastJob && !employment.end) ||
      _.isEmpty(employment.location) ||
      arePracticeAreasMandatory()
    ) {
      let errorText = ''
      let errorCount = 0
      if (!employment.start) {
        $scope.employment.errors.start = 'input-error'
        errorCount++
        errorText += " 'Start Date' "
      }

      if (!employment.isLastJob && !employment.end) {
        $scope.employment.errors.isCurrent = 'input-error'
        errorCount++
        errorText += " 'End Date' "
      }

      if (_.isEmpty(employment.location)) {
        $scope.employment.errors.location = 'input-error'
        errorCount++
        errorText += " 'Location' "
      }

      if (arePracticeAreasMandatory()) {
        $scope.employment.errors.specialties = 'input-error'
        errorCount++
        errorText += " 'Practice Areas' "
      }

      errorText += errorCount > 1 ? ' fields are missing' : ' field is missing'
      logger.notify('error', errorText)
      return false
    }

    if (
      !employment.isLastJob &&
      employment.start &&
      employment.end &&
      new Date(employment.start) > new Date(employment.end)
    ) {
      logger.notify(
        'error',
        "Employment's start date cannot be greater than the end date"
      )
      return false
    }

    if (
      employment.isLastJob &&
      employment.start &&
      new Date(employment.start) > new Date()
    ) {
      logger.notify(
        'error',
        "Current Employment's start date cannot be greater than current date"
      )
      return false
    }

    return true
  }

  $scope.findEmployerId = currentEmployer => {
    console.debug(`findEmployerId(${currentEmployer})`)

    var employerName = currentEmployer
      ? currentEmployer
      : $scope.employment.employer.name

    console.debug(`employerName: ${employerName}`)

    var employerIndex = $scope.employers.findIndex(employer => {
      return employer.name === employerName
    })

    console.debug(`employerIndex: ${employerIndex}`)

    if (employerIndex !== -1) {
      if (!currentEmployer) {
        if ($scope.employers[employerIndex].logo) {
          console.debug(`updating picture for $scope.employment`)
          $scope.employment.employerPicture = `${process.env.LEXSTEP_URL}/${$scope.employers[employerIndex].user.user_ID}/${$scope.employers[employerIndex].logo}`
        } else {
          $scope.employment.employerPicture = `images/firm-logo-default.jpg`
          $scope.employment.monthDiff = getTotalExperience(
            $scope.employment.start,
            $scope.employment.end
          )
        }
      }

      const found = $scope.employers[employerIndex]
      const id = found && found.id

      if (id) {
        console.debug(`found employer ID: ${id}`)
      } else {
        console.error(
          `Could not find employer ID for employer name: ${employerName}`
        )
      }

      return id
    }
  }

  $scope.updateCurrentEmployerAndResidence = isPresentHistoryDeleted => {
    if ($scope.employment.isLastJob) {
      console.debug(
        'updateCurrentEmployerAndResidence: last job change detected',
        'candidate.employer',
        $scope.candidate.employer,
        'employment.employer',
        $scope.employment.employer
      )

      $scope.candidate.employer = $scope.employment.employer
      if (
        $scope.candidateExperienceLocation &&
        $scope.candidateExperienceLocation.id &&
        $scope.employment &&
        $scope.employment.location &&
        $scope.employment.location.id
      ) {
        $scope.candidate.location =
          $scope.candidateExperienceLocation.id ===
          $scope.employment.location.id
            ? $scope.candidate.location
            : $scope.employment.location
      }

      $scope.$apply()
    } else if (isPresentHistoryDeleted) {
      $scope.candidate.employer = undefined
      $scope.candidate.location = undefined
      $scope.$apply()
    }
  }

  $scope.manageEmployment = () => {
    if ($scope.employment.id) {
      $scope.editEmployment($scope.employment.id)
    } else {
      $scope.addEmployment()
    }
  }

  $scope.addAdditionalEmpInfo = () => {
    const employer = $scope.findEmployerId()
    console.debug('addAdditionalEmpInfo: employer id is', employer)
    const employerName =
      ($scope.employment &&
        $scope.employment.employer &&
        $scope.employment.employer.name) ||
      ''
    console.debug(`employer name is "${employerName}"`)

    angular.extend($scope.employment, {
      lawyerId: $scope.lawyerId,
      end: $scope.employment.isLastJob ? undefined : $scope.employment.end,
      id: $scope.employment.id,
      isAdminChange: true,
      employerId: employer ? employer : $scope.employment.employer.name,
    })
    $scope.employment.contractType = $scope.contracts.find(contract => {
      return $scope.employment.contractTypeId === contract.id
    })
    $scope.employment.occupation = $scope.occupations.find(occupation => {
      return $scope.employment.occupationId === occupation.id
    })
  }

  $scope.editEmployment = async () => {
    console.debug('editEmployment: start', $scope.employment)
    $scope.candidateExperienceLocation = angular.copy(
      $scope.employment.location
    )

    if (!validateEmploymentParameters()) return

    $scope.addAdditionalEmpInfo()

    console.debug(
      `editEmployment: start is "${$scope.employment.start}" and end is "${$scope.employment.end}"`
    )

    const payload = Object.assign(
      {
        start: $scope.employment.start,
        isLastJob: $scope.employment.isLastJob,
        jobTitle: $scope.employment.jobTitle,
        employer: $scope.employment.employerId,
        occupationId: $scope.employment.occupation.id,
        contractTypeId: $scope.employment.contractType.id,
        locationId: $scope.employment.location.id,
        comments: $scope.employment.comments,
        specialties: $scope.employment.specialties.map(
          specialty => specialty.id
        ),
      },
      $scope.employment.end && {end: $scope.employment.end}
    )

    const {data} = await wrap(async () => {
      console.debug(
        `editEmployment(${$scope.candidate.id}, ${$scope.employment.id}): payload is`,
        payload
      )

      return EmploymentHistoryApi.editExperience(
        $scope.candidate.id,
        $scope.employment.id,
        payload
      )
    })

    console.debug('editEmployment: updated data is', data)

    const updatedExperience = formatFirmLogo([data])[0]
    $scope.employment = updatedExperience
    $scope.updateEditedEmploymentRecord(updatedExperience)
    $scope.employment = updatedExperience
    $scope.hideAddEmploymentHistoryForm()

    if (!$scope.findEmployerId(updatedExperience.employer.name))
      $scope.employers.push({
        id: updatedExperience.employer.id,
        name: updatedExperience.employer.name,
      })

    $scope.updateCurrentEmployerAndResidence()

    // TODO: re-enable segment
    // $scope.trackExperience($scope.employment, 'Edit')

    $scope.resetEmployment()

    $scope.$apply()
    logger.notify('success', 'Candidate Experience Successfully Updated!')
  }

  $scope.addEmployment = async () => {
    console.debug('addEmployment: START')
    if (!validateEmploymentParameters()) return

    $scope.addAdditionalEmpInfo()

    const payload = Object.assign(
      {
        start: $scope.employment.start,
        isLastJob: $scope.employment.isLastJob,
        jobTitle: $scope.employment.jobTitle,
        employer: $scope.employment.employerId,
        occupationId: $scope.employment.occupation.id,
        contractTypeId: $scope.employment.contractType.id,
        locationId: $scope.employment.location.id,
        comments: $scope.employment.comments,
        specialties: $scope.employment.specialties.map(
          specialty => specialty.id
        ),
      },
      $scope.employment.end && {end: $scope.employment.end}
    )

    const {data} = await wrap(async () =>
      EmploymentHistoryApi.addExperience($scope.candidate.id, payload)
    )

    const newExperience = formatFirmLogo([data])[0]
    $scope.employment = newExperience
    if (!$scope.findEmployerId(newExperience.employer.name))
      $scope.employers.push({
        id: newExperience.employer.id,
        name: newExperience.employer.name,
      })
    console.debug(
      'addEmployment: calling addEmploymentRecord',
      $scope.employment
    )
    $scope.addEmploymentRecord($scope.employment)
    console.debug('addEmployment: calling hideAddEmploymentHistoryForm')
    $scope.hideAddEmploymentHistoryForm()
    console.debug('addEmployment: calling updateCurrentEmployerAndResidenc')
    $scope.updateCurrentEmployerAndResidence()
    console.debug('addEmployment: calling trackExperience', $scope.employment)
    $scope.trackExperience($scope.employment, 'Add')
    $scope.resetEmployment()
    console.debug('addEmployment: DONE. will apply')

    $scope.$apply()

    console.debug('addEmployment: DONE. applied')
    logger.notify('success', 'Candidate Experience Successfully Added!')
    console.debug('addEmployment: NOTIFIED')
  }

  $scope.deleteEmployment = async (id, index) => {
    var modalInstance
    modalInstance = $modal.open({
      templateUrl: 'deleteExperienceModal.html',
      controller: function($uibModalInstance) {
        let vm = this
        vm.confirmAction = false
        vm.yes = () => {
          vm.confirmAction = true
          $uibModalInstance.close(vm.confirmAction)
        }

        vm.no = () => {
          $uibModalInstance.dismiss('cancel')
        }
      },
      controllerAs: 'deleteExperienceModalCtrl',
    })
    modalInstance.result.then(
      async selectedItem => {
        if (selectedItem) {
          try {
            await wrap(async () =>
              EmploymentHistoryApi.deleteExperience($scope.candidate.id, id)
            )
            const isPresentHistoryDeleted = !$scope.candidate.experiences[index]
              .end
            const deletedEmployment = angular.copy(
              $scope.candidate.experiences[index]
            )
            $scope.trackExperience(
              deletedEmployment,
              'Profile - Deleting Experience'
            )

            $scope.removeEmploymentRecord(index)
            $scope.updateCurrentEmployerAndResidence(isPresentHistoryDeleted)

            $scope.$apply()
            logger.notify(
              'success',
              'Candidate Experience Successfully Deleted!'
            )
          } catch (error) {
            console.error('error:', error)
            logger.notify(
              'error',
              'Error occurred on Candidate Experience Deletion'
            )
          }
        }
      },
      () => {}
    )
  }
}

let formatFirmLogo = histories => {
  histories.forEach(history => {
    if (history.employer.logo)
      history.employerPicture = `${process.env.PUBLIC_BUCKET_URL}/employers/${history.employer.id}/logo/${history.employer.logo}`
    else history.employerPicture = `images/firm-logo-default.jpg`
    history.monthDiff = getTotalExperience(
      history.start,
      history.isLastJob ? new Date() : history.end
    )
  })
  return histories
}

function getTotalExperience(from, to) {
  let ends = to ? moment(to) : moment()
  let starts = moment(from)
  let duration = moment.duration(ends.diff(starts))

  let totalExperience = ''
  let years = duration.years()
  let months = duration.months()
  let days = duration.days()

  if (days > 15) {
    months += 1
    days = 0
  }

  if (months >= 12) {
    years += 1
    months = 0
  }

  if (years > 0) {
    let yearString = years === 1 ? ' year ' : ' years '
    totalExperience = totalExperience + years + yearString
  }

  if (months > 0) {
    let monthString = months === 1 ? ' month ' : ' months '
    totalExperience = totalExperience + months + monthString
  }

  if (years === 0 && months === 0) {
    let dayString = days === 1 ? ' day ' : ' days '
    totalExperience = totalExperience + days + dayString
  }

  return totalExperience
}



// WEBPACK FOOTER //
// ./scripts/candidate-profile/employment-history/employment-history.js